module.exports = __webpack_public_path__ + "static/media/i8-1-phone-frame.df1abd43.png";